import { Skeleton } from "antd";

import { useState } from "react";

import "./NormativaPrivacy.css";
import INormativaPrivacy from "pages/NormativaPrivacy/INormativaPrivacy";

import { GetLocales } from "assets/customAssets";

const NormativaPrivacy: React.FC<INormativaPrivacy> = () => {
	const [loading] = useState<boolean>(false);

	var locales = GetLocales();
	// const customUrlExists = () => {
	// 	try {
	// 		return require(`${locales.CustomPrivacyPolicy}`);
	// 	} catch (err) {
	// 		return null;
	// 	}
	// };

	// const getUrl = () => {
	// 	if (customUrlExists()) {
	// 		return locales.CustomPrivacyPolicy;
	// 	} else {
	// 		return locales.PrivacyPolicy;
	// 	}
	// };

	return (
		<>
			{loading ? (
				<Skeleton active />
			) : (
				<>
					<div id="normativaPrivacy">
						{
							<>
								<iframe title="policy-GA" allowFullScreen src={locales.CustomPrivacyPolicy} />
							</>
						}
					</div>
				</>
			)}
		</>
	);
};

export default NormativaPrivacy;
